module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-3.ed425de8.webp";